/* @flow weak */
import _ from 'lodash';
import InvitationActions from 'groups/actions/InvitationActions';
import RecipientParser from 'lib/RecipientParser';
import ToastActions from 'actions/ToastActions';

function onSuccess(participantsSnapshot, response, successCallback) {
  const nonEmptyParticipants = participantsSnapshot.filter(
    participant => participant.uid || participant.name);

  // The participant rows that were sent to the server
  const submittedParticipants = nonEmptyParticipants.filter(participant => participant.valid);

  // The participant rows that are invalid, but not empty
  const invalidParticipants = nonEmptyParticipants.filter(participant => !participant.valid);

  // Errors returned from the server
  const serverErrors = Object.keys(response).filter(key => {
    return key.startsWith('sms://') || key.startsWith('email://');
  });

  // Map server errors to submitted participants by matching on uid
  const erroredParticipants = [];
  serverErrors.forEach(error => {
    const matchingParticipant = submittedParticipants.find(p => {
      return error.indexOf(p.uid.trim()) > -1;
    });
    if (matchingParticipant) {
      erroredParticipants.push({
        ...matchingParticipant,
        serverErrors: { uid: response[error].error.recipient[0] },
      });
    }
  });

  // The number of participants for whom the invite was sent successfully
  const numberSuccessful = nonEmptyParticipants.length -
    (serverErrors.length + invalidParticipants.length);

  if (!Object.keys(response).length && !invalidParticipants.length) {
    ToastActions.showSuccessToast('Participants successfully added');
    successCallback([]);
  } else {
    if (numberSuccessful > 0) {
      ToastActions.showSuccessToast(
        `${numberSuccessful} of ${nonEmptyParticipants.length} participants successfully added`);
    } else {
      ToastActions.showErrorToast(
        `0 of ${nonEmptyParticipants.length} participants could be added :(`);
    }
    // Set state to leave only invalid rows or rows for which a server error occurred
    invalidParticipants.forEach(p => { p.pasted = true; }); // in order to re-validate
    erroredParticipants.forEach(p => { p.valid = false; }); // rows with server errs aren't valid
    const remainingParticipants = invalidParticipants.concat(erroredParticipants);
    successCallback(remainingParticipants);
  }
}

function onFailure(participantsSnapshot, response, successCallback, failCallback) {
  if (response.statusCode === 422) {
    // There was an error, but one or more invites may have been successful.
    onSuccess(participantsSnapshot, response, successCallback);
  } else {
    ToastActions.showDefaultErrorToast();
    failCallback();
  }
}

export function getParticipantsSnapshot(participants) {
  const uniqueParticipants = _.uniqBy(participants.filter(p => p), 'uid');
  return _.cloneDeep(uniqueParticipants);
}

export function getValidParticipants(participants) {
  const validParticipants = [];

  participants.forEach(participant => {
    if (participant.uid && participant.valid) {
      validParticipants.push(participant);
    }
  });

  return validParticipants;
}

export function directAddSubmit(group, participants, successCallback, failCallback) {
  const participantsSnapshot = getParticipantsSnapshot(participants);
  const validParticipants = getValidParticipants(participantsSnapshot);
  const submitParticipants = validParticipants.map(participant => {
    return {
      name: participant.name || '',
      address: RecipientParser.newToken(participant.uid).address,
    };
  });
  const onSubmissionSuccess =
    (response) => onSuccess(participantsSnapshot, response, successCallback);
  const onSubmissionError =
    (response) => onFailure(participantsSnapshot, response, successCallback, failCallback);
  const groupId = group.id;

  InvitationActions
    .invite(groupId, submitParticipants)
    .then(onSubmissionSuccess, onSubmissionError);
}



// WEBPACK FOOTER //
// ./src/lib/directAddHelper.js